import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import {Space, Tag, Table, Button} from 'antd';
import moment from 'moment';
import MerchantService from "../../../services/ewallet_integration/merchant.service";

const MerchantTable = ({ filter, refresh, setRefresh }) => {
    const [state, setState] = useState({
        loading : false,
        rows : [],
        count : 0,
    });
    const history = useHistory();

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Wallet",
            dataIndex: ["wallet", "name"],
            key: "wallet_name",
        },

        {
            title: "Melon Balance",
            dataIndex: ['wallet','melon_balance'],
            key: "melon_amount",
            render: (melon) => melon ? Number(melon).toFixed(2) : "0.00",
        },
        {
            title: "Date",
            dataIndex: "created_at",
            key: "created_at",
            render: (created_at) => <span>{moment(created_at)?.format("YYYY-MM-DD hh:mm:ssa")}</span>,
        },
        {
            title: "Action",
            dataIndex: 'merchant_id',
            key: "merchant_id",
            render: (v, r) => {
                return (
                    <>
                        <Button onClick={() => history.push(`/merchants/${r.merchant_id}`)}>
                            View
                        </Button>
                    </>
                );
            },
        },
    ];

    const fetchListing = async () => {
        setState(state => ({...state, loading : true, }));
        const { search, } = filter;
        const response = await MerchantService?.merchants_listing({
            search,
        });
        const {  rows } = response?.data?.listings;

        setState(state => ({...state, loading : false, rows : rows, }));
    }

    useEffect(() => {
        fetchListing();
    }, [filter,])

    useEffect(() => {
        if(refresh) {
            fetchListing();
            setRefresh(false);
        }
    }, [refresh])

    return (
        <>
            <Table
                rowKey="merchant_id"
                scroll={{ x : 400, }}
                size='small'
                pagination={false}
                className='hub-table bordered'
                dataSource={state?.rows}
                columns={columns}
            />
        </>
    );
}

export default MerchantTable;